import React, {createRef} from 'react';
import {Menu, Dropdown} from 'semantic-ui-react';
import {Component, Fragment, indicators, demographics, jQuery, years, captions, ranges, titles} from './Helpers';
import {TRANS_TIME, MIN_DOT, MAX_DOT} from './Constants';
import {CSSTransitionGroup} from 'react-transition-group';
import Context from './Context';
import * as d3 from 'd3';
import {clamp} from 'lodash';
import {default as UUID} from "node-uuid";
import { interpolatePath } from 'd3-interpolate-path';


/*<div className="caption" dangerouslySetInnerHTML={{ __html: this.props.ui ? captions[this.props.indicator][this.props.demographic] : null }} ></div>*/

class BaseChart extends Component {
  constructor(props){
    super(props);
    this.state =  {
      drawn: false
    }
	this.contextRef = createRef();
    this.debug = false;
    this.svg = null;
    this.bisector = d3.bisector(d => d.year ).right;
    this.x = d3.scaleLinear();
    this.y = d3.scaleLinear();

    this.xAxis = d3.axisBottom().scale(this.x).ticks().tickFormat((d,i,j) =>
      //`${typeof years[this.props.indicator] == 'object' ? years[this.props.indicator][d] : years[this.props.indicator] + d}`);
      `${i == 0 || i == j.length-1 ? `${typeof years[this.props.indicator] == 'object' ? years[this.props.indicator][d] : years[this.props.indicator] + d}` : `` }`);


    this.yAxis = d3.axisLeft().scale(this.y).ticks(6).tickFormat((d,i,j) => i % 2 != 0 && i != j.length - 1 ? `` : ~['household-income', 'median-wealth'].indexOf(this.props.indicator)  ?
      i == j.length - 1 ? d3.format('$.2s')(d) : d3.format('.2s')(d).split('k')[0] :
      i == j.length - 1 && this.props.indicator != 'life-expectancy' ? `${d}%` : `${d}`);


    this.valueline = d3.line()
        .defined(d => d !== null)
        .x( (d,i)  =>  this.x(i))
        .y( (d,i)  => this.y(d));
  }

  mouseout = () => {
	  let _demographic = new Array(...this.props.demographic.values());
    d3.selectAll('.dot.first')
      .transition(d3.easeCircle)
      .duration(50)
      .attr('r', (d,e) => this.props.data[this.props.indicator][_demographic[0]][e+1] === null ? 1.25 : MIN_DOT);

    d3.selectAll('.dot.second')
      .transition(d3.easeCircle)
      .duration(50)
      .attr('r', (d,e) => this.props.data[this.props.indicator][_demographic[1]][e+1] === null ? 1.25 : MIN_DOT);


      for (let item of document.querySelectorAll(`#${this.state.id} .tooltip`)) {
        item.classList.remove('visible');
      }

      for (let item of document.querySelectorAll(`#${this.state.id} .recession`)) {
        item.classList.remove('dim');
      }

    document.querySelector(`#${this.state.id} .year`).classList.remove('visible');
    document.querySelector(`#${this.state.id} .x.axis`).classList.remove('hover');
    document.querySelector(`#${this.state.id} .chart`).classList.remove('hover');
  }


  format = (value) => {
	  return `${~['household-income', 'median-wealth'].indexOf(this.props.indicator) ? this.format_dollar(value) :
	  	this.props.indicator  == 'life-expectancy' ? this.format_year(value) :
	  	 this.format_percent(value)}`;
  }

  format_dollar = (value) => {
    return value >= 100000 ? d3.format('$.4s')(value) :
      value < 1000 ? d3.format('$.1s')(value) :
      value < 10000 ? d3.format('$.2s')(value) :
      d3.format('$.3s')(value);
  }

  format_year = (value) => {
    return `${d3.format(`${value >=10 ? '.2s' : '.1s'}`)(value)} years`;
  }

  format_percent = (value) => {
    return `${ value < 1 ? '< 1' : d3.format(`${value >=10 ? '.2s' : '.1s'}`)(value)}%`;
  }


  format_gap = (value) => {
	  return `${this.format(value)} ${~['household-income', 'median-wealth', 'life-expectancy'].indexOf(this.props.indicator) ? '' : value < 1.5 ? 'pt.' : 'pts.'}`;
  }

  showGap = (i) => {
    console.log(`blarg ${i}`);
	  if (this.props.demographic.size < 2) return;
	  let _demographic = new Array(...this.props.demographic.values()),
	  	first = this.props.data[this.props.indicator][_demographic[0]][i],
	  	second = this.props.data[this.props.indicator][_demographic[1]][i],
      g = document.querySelector(`.chartContainer .tooltip.gap`),
      y = document.querySelector(`#${this.state.id} .year`),
      x = this.x(i);

   d3.selectAll(`#${this.state.id} .dot.first`)
      .transition(d3.easeCircle)
      .duration(70)
      .attr('r', (d,e) => e == i ? MAX_DOT : this.props.data[this.props.indicator][_demographic[0]][e+1] === null ? 1.25 : MIN_DOT);

    d3.selectAll(`#${this.state.id} .dot.second`)
      .transition(d3.easeCircle)
      .duration(70)
      .attr('r', (d,e) => e == i ? MAX_DOT : this.props.data[this.props.indicator][_demographic[1]][e+1] === null ? 1.25 : MIN_DOT);

    d3.select(`#${this.state.id} .year`)
    .transition(d3.easeCircle)
    .duration(50)
    .attr('x', x);
    y.classList.add('visible');
    document.querySelector(`#${this.state.id} .x.axis`).classList.add('hover');
    document.querySelector(`#${this.state.id} .chart`).classList.add('hover');


    let gap = Math.abs(first-second);

    console.log(`first: ${_demographic[0]}  ${first} second: ${_demographic[1]} ${second} gap ${gap}`);

    this.t1
     .attr('class', `tooltip first ${_demographic[0]} ${first !== null ? 'visible' : ''}`)
     .attr('x', x < 100 ? x + 10 : x - 10)
     .attr('y', clamp(this.y(first) - (second >= first ? -25 : 15), 20, 400))
     .text(`${_demographic[0]} `)
     .attr('text-anchor', x < 100 ? 'start' : 'end')
     .append('tspan')
     .text(this.format(first))
     ;


     this.t2
     .attr('class', `tooltip second ${_demographic[1]} ${second !== null ? 'visible' : ''}`)
     .attr('x', x < 100 ? x + 10 : x - 10)
     .attr('y', clamp(this.y(second) - ( first > second ? -25 : 15), 20, 400))
     .text(`${_demographic[1]} `)
     .attr('text-anchor', x < 100 ? 'start' : 'end')
     .append('tspan')
     .text(this.format(second))
     ;


     this.gap
      .attr('class', `tooltip gap ${first !== null && second !== null ? 'visible' : ''}`)
      .attr('x', x)
      .attr('y', -5)
      .attr('text-anchor', x < 100 ? 'start' : 'end')
      .text(`Gap of ${this.format_gap(gap)}`);


	  this.year
	  	.attr('class', 'tooltip y visible' )
	  	.attr('x', x)
	  	.attr('y', this.y.range()[0] + 18)
	  	.attr('text-anchor', 'middle')
	  	.text(`${typeof years[this.props.indicator] == 'object' ? years[this.props.indicator][i] : years[this.props.indicator] + i}`);

  }

  mousemove = () => {
    let _demographic = new Array(...this.props.demographic.values());
    let x0 = window.navigator.userAgent.indexOf('Firefox') > -1 && this.props.width >= 720 ? this.x.invert(d3.event.offsetX) : this.x.invert(d3.mouse(d3.select(`#${this.state.id} .overlay`).node())[0]),
          i = this.bisector(this.props.data[this.props.indicator][_demographic[0]].map( (d,i) => { return {value: d, year: i};}), x0 - .3, 0,this.props.data[this.props.indicator][_demographic[0]].length);

	this.showGap(i);

  }


  draw = ( step, indicator, demographic) => {
          let d = this.props.data;
          this.refs.chart.innerHTML = ``;
          const margin = {top: 20, right: 14, bottom: 44, left: 42},
            width = document.querySelector(`#${this.state.id} .chart`).clientWidth - margin.left - margin.right,
            height = document.querySelector(`#${this.state.id} .chart`).clientHeight - margin.top - margin.bottom;


          this.x.range([0, width]).interpolate(d3.interpolateRound);
          this.y.range([height, 0]).interpolate(d3.interpolateRound);

          this.svg = d3.select(`#${this.state.id} .chart`)
              .append("svg")
                  .attr("width", width + margin.left + margin.right)
                  .attr("height", height + margin.top + margin.bottom)
              .append("g")
                  .attr("transform",
                        "translate(" + margin.left + "," + margin.top + ")");


          this.x.domain(d3.extent(d[indicator].white, function(d, i) { return i; }));

          this.y.domain(ranges[indicator]);



            this.svg.append("g")
                .attr("class", "x axis")
                .attr("transform", "translate(0," + height + ")")
                .call(this.xAxis.tickSize(-height))
                .call(this.xAxis.tickValues(this.x.ticks(5).concat(this.x.domain())));


            this.svg.append("g")
                .attr("class", "y axis")
                .call(this.yAxis.tickSize(-width));


           this.svg.append('rect')
              .attr('class', 'year')
              .attr('x', 0)
              .attr('width', 2)
              .attr('y', 0)
              .attr('height', height);


            this.svg.append('rect')
              .attr('class', 'overlay')
              .attr('width', width)
              .attr('height', height)
              .on('mouseout', () =>  this.mouseout())
              .on('mousemove', () =>  this.mousemove());

             this.t1 = this.svg.append('text')
           	.attr('class', 'tooltip first');

           this.t2 = this.svg.append('text')
           	.attr('class', 'tooltip second');

           this.gap = this.svg.append('text')
           	.attr('class', 'tooltip gap');

           this.year = this.svg.append('text')
           	.attr('class', 'tooltip y');

           if (demographic.size == 2) {

           let _demographic = new Array(...demographic.values());
	       const data = d[indicator][_demographic[0]];


            // Add the valueline path.
            this.svg.append("path")
                .datum(d[indicator][_demographic[1]])
                .attr("class", `line second ${_demographic[1]}`)
                .attr("d", this.valueline(d[indicator][_demographic[1]]));

            this.svg.append("path")
                .datum(d[indicator][_demographic[0]])
                .attr("class", `line first ${_demographic[0]}`)
                .attr("d", this.valueline(d[indicator][_demographic[0]]));

            this.svg.selectAll(".dot.second")
                .data(d[indicator][_demographic[1]])
                .enter()
                .append("circle")
                .attr("class", `dot second ${_demographic[1]}`)
                .style('display', d => d === null ? 'none' : 'inherit')
                .attr("cx", (d,i) => this.x(i))
                .attr("cy", d => this.y(d))
                .attr("r", (e,i) => d[indicator][_demographic[1]][i+1]  === null ? 1.25 : MIN_DOT);


            this.svg.selectAll(".dot.first")
                    .data(d[indicator][_demographic[0]])
                    .enter()
                    .append("circle")
                    .attr("class", `dot first ${_demographic[0]}`)
                    .style('display', d => d === null ? 'none' : 'inherit')
                    .attr("cx", (d,i) => this.x(i))
                    .attr("cy", d => this.y(d))
                    .attr("r", (e,i)=> d[indicator][_demographic[0]][i+1]  === null ? 1.25 : MIN_DOT);


            let first = this.props.data[this.props.indicator][_demographic[0]][Math.floor(this.props.data[this.props.indicator][_demographic[0]].length/2)];
            let second = this.props.data[this.props.indicator][_demographic[1]][Math.floor(this.props.data[this.props.indicator][_demographic[1]].length/2)];
            this.label1 = this.svg.append('text')
           	.attr('class', `tooltip label first ${_demographic[0]}`)
           	.attr('x', this.x(Math.floor(this.props.data[this.props.indicator][_demographic[0]].length/2)))
		     .attr('y', clamp(this.y(first) - (second >= first ? -25 : 15), 20, 400))
		    .text(`${_demographic[0]} `)
           	;

           this.label2 = this.svg.append('text')
           	.attr('class', `tooltip label first ${_demographic[1]}`)
           	.attr('x', this.x(Math.floor(this.props.data[this.props.indicator][_demographic[1]].length/2)))
		     .attr('y', clamp(this.y(second) - ( first > second ? -25 : 15), 20, 400))
		    .text(`${_demographic[0]} `)
           	;
           	    this.showGap(this.props.data[this.props.indicator][_demographic[0]].length -1);
          }

           this.setState({drawn: true});
    }

  redraw = (step, indicator, demographic, prevProps) => {

  		  if (typeof this.label1 != 'undefined') this.label1.remove();
		  if (typeof this.label2 != 'undefined') this.label2.remove();

      const d = this.props.data;

      this.x.domain(d3.extent(d[indicator].white, function(d, i) { return i; }));

        this.y.domain(ranges[indicator]);


       const transition = d3.select(`#${this.state.id} .chart`).transition();


        transition.select(".x.axis")
            .duration(TRANS_TIME)
            .call(this.xAxis)
            .call(this.xAxis.tickValues(this.x.ticks(5).concat(this.x.domain())));
        transition.select(".y.axis")
            .duration(TRANS_TIME)
            .call(this.yAxis);

        transition.select('.x.title')
        .duration(TRANS_TIME)
        .attr('x', () => this.x(2));

       if (demographic.size < 2) {
         for (let item of document.querySelectorAll(`#${this.state.id} .tooltip`)) {
           item.classList.remove('visible');
         }
	       d3.selectAll(`#${this.state.id} .dot`).remove();
	       d3.selectAll(`#${this.state.id} .line`).remove();
	       return;
       }


       	let _demographic = new Array(...demographic.values());
		const data = d[indicator][_demographic[0]];

       if (typeof document.querySelectorAll('.line')[0] == 'undefined') {
	                   // Add the valueline path.
            this.svg.append("path")
                .datum(d[indicator][_demographic[1]])
                .attr("class", `line second ${_demographic[1]}`)
                .attr("d", this.valueline(d[indicator][_demographic[1]]));

            this.svg.append("path")
                .datum(d[indicator][_demographic[0]])
                .attr("class", `line first ${_demographic[0]}`)
                .attr("d", this.valueline(d[indicator][_demographic[0]]));
       }



/*
       transition.select(".line.second")
           .duration(750)
           .attr("d", this.valueline(d[indicator][_demographic[1]]));
       transition.select(".line.first")
           .duration(750)
           .attr("d", this.valueline(d[indicator][_demographic[0]]));
*/

		d3.select('.line.second')
		  .transition()
		  .duration(TRANS_TIME)
		  .attrTween('d', ()=> {
		    let previous = d3.select('.line.second').attr('d');
		    let current = this.valueline(d[indicator][_demographic[1]]);
		    return interpolatePath(previous, current);
		  });


		d3.select('.line.first')
		  .transition()
		  .duration(TRANS_TIME)
		  .attrTween('d', ()=> {
		    let previous = d3.select('.line.first').attr('d');
		    let current = this.valueline(d[indicator][_demographic[0]]);
		    return interpolatePath(previous, current);
		  });

        if (prevProps.indicator != indicator || typeof document.querySelectorAll('.dot')[0] == 'undefined') {
          d3.selectAll(`#${this.state.id} .dot`).remove();
          this.svg.selectAll(".dot.second")
              .data(d[indicator][_demographic[1]])
              .enter()
              .append('circle')
              .attr("class", `dot second ${_demographic[1]}`)
              .style('display', d => d === null ? 'none' : 'inherit')
              .attr("cx", (d,i) => this.x(i))
              .attr("cy", d => this.y(d))
              .attr("r", 0);


          this.svg.selectAll(".dot.first")
                  .data(d[indicator][_demographic[0]])
                  .enter()
                  .append('circle')
                  .attr("class", `dot first ${_demographic[0]}`)
                  .style('display', d => d === null ? 'none' : 'inherit')
                  .attr("cx", (d,i) => this.x(i))
                  .attr("cy", d => this.y(d))
                  .attr("r", 0);


        //  this.svg.selectAll('.dot.second')
        //           .transition(d3.easeBackOut)
        //           .delay((d,i) => (this.props.ui ? 650 : 150) + i * 25)
        //           .duration(625)
        //           .attr('r', (e,i) => d[indicator][_demographic[1]][i+1] === null ? 1.25 : MIN_DOT);
        //
        // this.svg.selectAll('.dot.first')
        //          .transition(d3.easeBackOut)
        //          .delay((d,i) => (this.props.ui ? 650 : 150) + i * 25)
        //          .duration(625)
        //          .attr('r', (e,i) => d[indicator][_demographic[0]][i+1]  === null ? 1.25 : MIN_DOT);
        } else {
          // this.svg.selectAll(".dot.second")
          //     .data(d[indicator][_demographic[1]])
          //     .transition()
          //     .duration(750)
          //     .attr("cx", (d,i) => this.x(i))
          //     .attr("cy", d => this.y(d));
          //
          //
          // this.svg.selectAll(".dot.first")
          //     .data(d[indicator][_demographic[0]])
          //     .transition()
          //     .duration(750)
          //     .attr("cx", (d,i) => this.x(i))
          //     .attr("cy", d => this.y(d));
        }
          this.t1.remove();
          this.t2.remove();

          this.t1 = this.svg.append('text')
           	.attr('class', 'tooltip first');

           this.t2 = this.svg.append('text')
           	.attr('class', 'tooltip second');


            let first = this.props.data[this.props.indicator][_demographic[0]][Math.floor(this.props.data[this.props.indicator][_demographic[0]].length/2)];
            let second = this.props.data[this.props.indicator][_demographic[1]][Math.floor(this.props.data[this.props.indicator][_demographic[1]].length/2)];
            this.label1 = this.svg.append('text')
           	.attr('class', `tooltip label first ${_demographic[0]}`)
           	.attr('x', this.x(Math.floor(this.props.data[this.props.indicator][_demographic[0]].length/2)))
		     .attr('y', clamp(this.y(first) - (second >= first ? -25 : 15), 20, 400))
		    .text(`${_demographic[0]} `)
           	;

           this.label2 = this.svg.append('text')
           	.attr('class', `tooltip label first ${_demographic[1]}`)
           	.attr('x', this.x(Math.floor(this.props.data[this.props.indicator][_demographic[1]].length/2)))
		     .attr('y', clamp(this.y(second) - ( first > second ? -25 : 15), 20, 400))
		    .text(`${_demographic[1]} `)
           	;
	if (!(~['life-expectancy', 'median-wealth'].indexOf(this.props.indicator) && this.props.demographic.has('asian') )) {
        for (let item of document.querySelectorAll(`#${this.state.id} .tooltip`)) {
          item.classList.remove('visible');
        }
	      setTimeout(()=> {
          this.showGap(this.props.data[this.props.indicator][_demographic[0]].length - (this.props.indicator == 'life-expectancy' ? 2 : 1));
        }, TRANS_TIME);
	   }
   }


  componentWillMount(){
    this.setState({id: `chart-${UUID.v4()}`});

  }

  componentDidMount() {
    if(typeof this.props.data == 'undefined' ) return;
    this.draw(this.props.step, this.props.indicator, this.props.demographic);
  }


  componentDidUpdate(prevProps) {
    if(typeof this.props.data == 'undefined' ) return;
    this.props.step = typeof this.props.lockStep !== 'undefined' ? this.props.lockStep : this.props.step;
    this.props.indicator = typeof this.props.lockIndicator !== 'undefined' ? this.props.lockIndicator : this.props.indicator;
    this.props.demographic = typeof this.props.lockDemographic !== 'undefined' ? this.props.lockDemographic : this.props.demographic;
    if (this.state.drawn === true && prevProps.width === this.props.width) {
      this.redraw(this.props.step, this.props.indicator, this.props.demographic, prevProps);
    } else {
      this.draw(this.props.step, this.props.indicator, this.props.demographic);
    }
  }

  render() {
    const step = this.props.lockStep || this.props.step;
    return (
      <div id={this.state.id} ref={this.contextRef} className="chartContainer" data-step={step} style={{width: this.props.ui && this.props.width > 720 ? '80%' : '100%', marginLeft:  '-20px'}}>
      <p className="subhed" style={{fontFamily: 'Georgia', fontStyle: 'italic', color: '#888', fontSize: '1.2rem', marginLeft: '6rem', marginBottom: '.5em', marginTop: '.5em'}}>{titles[this.props.indicator][1]}</p>
        <div ref='chart' className={`chart ${this.props.ui ? `last` : ``}`} data-step={step} style={{width: '100%', marginLeft: 0}}></div>

	       { ~['life-expectancy', 'median-wealth'].indexOf(this.props.indicator) && this.props.demographic.has('asian') ?
              <div className="warning">Data for Asian adults unavailable.<br/>Please select another demographic group or indicator.</div> :
              this.props.demographic.size < 2 ? <div className="warning">Choose two demographic groups for comparison.</div> :
            ``
            }
      </div>
    );
  }
}


class Chart extends Component {
	constructor(props){
		super(props);
	}

  render() {
      const options = [].concat(...indicators).map(d=> {return {key: d.key, text: d.name, value: d.key, disabled: this.props.demographic.has('asian') && ~['median-wealth', 'life-expectancy'].indexOf(d.key) ? true : false};});
      return (
        <Context.Consumer>
         {({step, indicator, width, data, demographic, set_indicator, set_demographic}) => (
          <div className="chart-ui" data-step={step}>

          { this.props.ui ?
             <Menu fluid widths={4} id='top-menu' >
             {
               demographics.map( d => <Menu.Item as="a" name={d.key} content={d.name} active={demographic.has(d.key)} onClick={ (e,d) => set_demographic(e,d)} /> )
             }
             </Menu> : null }
           { this.props.ui ? width < 720 ?
            <Dropdown fluid selection options={options} text={titles[indicator][0]} value={demographic} onChange={ (f,d) => { setTimeout(()=>set_indicator(f,{name:d.value, key:d.value}), 50);}}/> :
             <Menu secondary vertical id='left-menu' size='tiny'>
             {
                 indicators.map( e =>
                     <Menu.Item> {e.map( d =>
                       <Menu.Item as="a" name={d.key} content={d.name} active={indicator === d.key} disabled={~['life-expectancy', 'median-wealth'].indexOf(d.key) && demographic.has('asian') }
                        onClick={ (f,d) => set_indicator(e,d)} />
                     )}
                     </Menu.Item>
                   )
             }
             </Menu>
           : null }

              <BaseChart data={data} width={width} step={step} indicator={indicator} demographic={demographic} {...this.props} />
          </div>
        )}
         </Context.Consumer>
      );
  }
}

export default Chart;
